import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FileUpload"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M7.5 3.59876V11.5351H6V3.59876L4.0575 5.51777L3 4.46901L6.75 0.75L10.5 4.46901L9.4425 5.51777L7.5 3.59876ZM19.4999 9.8616V21.7624H7.49994V13.01H6V21.7624C6 22.584 6.67157 23.25 7.5 23.25H19.5C20.3284 23.25 21 22.584 21 21.7624V8.374C21.0054 8.17617 20.9231 7.98592 20.775 7.85334L15.525 2.64672C15.3913 2.49981 15.1995 2.41827 15 2.42358H11.2497V3.91118H13.4999V8.37399C13.4999 9.19557 14.1715 9.8616 14.9999 9.8616H19.4999ZM19.2 8.37403L15 4.20874V8.37403H19.2Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FileUpload.vue"]]);
